import { useEffect, useRef } from 'react';

export default function useWatch(value, ignoreInitialChange) {
  const ref = useRef(ignoreInitialChange ? value : undefined);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current !== value;
}
